<template>
  <hic-dialog @open="open" @close="close" :close-on-click-modal="false" class="center" :visible="visible" append-to-body title="选择床位" width="60rem" top="4vh">
    <el-row type="flex" justify="center" class="bottom-pad" align="middle">
      <el-checkbox v-model="meta.onlyEmpty" @change="queryBed">空床</el-checkbox>
      <el-checkbox v-model="meta.onlyDept" @change="queryBed">本科</el-checkbox>
      <hic-dict-selector v-if="!setting.isSimple" dict-type="BedType" v-model="condition.type" class="edit-input left-pad" @change="queryBed" @clear="queryBed" placeholder="床位类型" />
      <hic-dict-selector v-if="!setting.isSimple" dict-type="IpWard" v-model="condition.wardCode" class="edit-input left-pad" @change="queryBed" @clear="queryBed" placeholder="病区" />
      <el-cascader v-model="site" :options="options" :props="{ expandTrigger: 'hover', value: 'code', label: 'text', checkStrictly: true }" size="small" class="left-pad" style="width: 18rem" placeholder="病房位置" clearable></el-cascader>
      <el-input v-model="condition.no" placeholder="床位号" size="small" v-on:keyup.enter.native="queryBed" clearable @clear="queryBed" class="edit-wide left-pad">
        <el-button type="info" :loading="meta.loading" slot="append" icon="el-icon-search" @click="queryBed"></el-button>
      </el-input>
    </el-row>

    <el-skeleton v-if="meta.loading" />
    <div v-else>
      <el-empty v-if="!entities.items.length" description="暂无床位！"></el-empty>
      <el-scrollbar v-else style="height: 43rem; padding: 0.5rem 0; border-top: solid 1px #dcdfe6; border-bottom: solid 1px #dcdfe6">
        <el-card v-for="building in buildings" :key="building.id" class="bottom-pad" shadow="hover">
          <el-row slot="header">
            <b class="info"><i class="el-icon-office-building" /> {{ building.text }}</b>
          </el-row>
          <el-container v-for="floor in floors.filter((f) => f.parentCode === building.code)" :key="floor.id" class="bottom-pad" shadow="hover" style="border-bottom: solid 5px #ebeef5">
            <el-aside width="1rem" class="center right-pad bottom-pad">
              <span class="info"><i class="el-icon-school" /> {{ floor.text }}</span>
            </el-aside>
            <el-main>
              <el-col v-for="room in rooms.filter((r) => r.parentCode === floor.code)" :key="room.id" :span="6">
                <el-card shadow="hover" class="bottom-pad right-pad" body-style="padding:10px;min-height:130px">
                  <el-row class="center bottom-pad">
                    <el-link><i class="el-icon-s-home" /> {{ room.text }}</el-link>
                    <el-link type="primary" icon="el-icon-circle-plus-outline" class="left-pad" :underline="false"></el-link>
                  </el-row>
                  <el-button
                    v-for="bed in entities.items.filter((b) => b.room === room.code)"
                    :key="bed.id"
                    :type="bed.ipNo ? 'info' : bed.disabled ? 'danger' : 'success'"
                    size="mini"
                    class="left bottom-pad f-w"
                    :style="bedStyle(bed)"
                    @click="selectBed(bed)"
                    plain
                    :disabled="bed.disabled || !!bed.ipNo"
                  >
                    <b><i v-if="!!bed.ipNo" class="el-icon-user-solid primary" /><i v-else-if="bed.disabled" class="el-icon-folder-delete" /><i v-else-if="bed.ifExtra" class="el-icon-folder-add" /><i v-else class="el-icon-folder" /> {{ bed.no }}</b>
                    <span type="info" size="mini" class="left-pad" style="line-height: 20px">{{ bed.type | dictText("BedType") }}</span>
                    <el-tag v-if="bed.ifExtra" type="warning" size="mini" hit class="left-pad">加</el-tag>
                    <el-tag v-if="bed.disabled" type="danger" size="mini" hit class="left-pad">停</el-tag>
                  </el-button>
                </el-card>
              </el-col>
            </el-main>
          </el-container>
        </el-card>
        <!-- <el-card v-for="(bCode, index) in Object.keys(buildings)" :key="index" class="bottom-pad">
          <div slot="header"><i class="el-icon-school" /> {{ bCode | dictText("Building") }}</div>
          <el-row :gutter="20">
            <el-col v-for="(rCode, idx) in Object.keys(buildings[bCode])" :key="idx" :span="8">
              <el-card shadow="never" class="bottom-pad" body-style="padding:10px">
                <div slot="header"><i class="el-icon-house" /> {{ rCode | dictText("Room") }}</div>
                <el-button v-for="(bed, i) in buildings[bCode][rCode]" :key="i" :type="bed.selected ? 'primary' : ''" size="small" class="left-pad bottom-pad" :style="bedStyle(bed)" :disabled="!!bed.ipNo || bed.disabled" @click="selectBed(bed)">
                  {{ bed.no }} {{ bed.type | dictText("BedType") }} <i v-if="bed.ifExtra">加</i> <i v-if="bed.disabled">故障</i>
                </el-button>
              </el-card>
            </el-col>
          </el-row>
        </el-card> -->
      </el-scrollbar>
    </div>

    <template slot="footer">
      <el-button type="info" size="large" @click.native="$emit('update:visible', false)">关闭</el-button>
    </template>
  </hic-dialog>
</template>

<script>
  import { mapGetters, apiFuns } from "sw-hic";
  let api = {
    Bed: apiFuns.genStandard("bed", "api/ip", false, true),
  };
  export default {
    name: "hic-bed-dialog",
    props: {
      visible: Boolean,
      hospitalization: Object,
    },
    data() {
      return {
        condition: {
          no: null,
          type: null,
          wardCode: null,
        },
        meta: {
          loading: false,
          onlyEmpty: false,
          onlyDept: false,
        },
        emptyBeds: [],

        site: [],
        entities: { items: [] },
      };
    },
    computed: {
      ...mapGetters(["dict", , "Enum", "dictEnum", "user", "setting"]),
      options() {
        let list = [];
        list.push(...this.dict.Building);
        list.push(...this.dict.Floor);
        list.push(...this.dict.Room);
        return this.$utils.Cascade.make(list);
      },
      buildings() {
        return this.dict.Building.filter((b) => !this.site[0] || b.code == this.site[0]);
      },
      floors() {
        return this.dict.Floor.filter((f) => !this.site[1] || f.code == this.site[1]);
      },
      rooms() {
        return this.dict.Room.filter((r) => !this.site[2] || r.code == this.site[2]);
      },
    },
    methods: {
      open() {
        this.condition = {
          no: null,
          type: null,
          wardCode: null,
        };
        this.site = [];
        this.onlyEmpty = false;

        this.siteChange([]);
      },
      close() {
        this.$emit("update:visible", false);
      },
      selectBed(bed) {
        if (bed.ipNo || bed.disabled) {
          return;
        }
        this.$emit("selected", bed);
      },
      siteChange(building) {
        this.condition.building = building[0];
        this.condition.floor = building[1];
        this.condition.room = building[2];
        this.queryBed();
      },
      queryBed() {
        if (this.meta.onlyEmpty) {
          this.condition.nulls = "ipNo";
        } else {
          delete this.condition.nulls;
        }
        if (this.meta.onlyDept) {
          this.condition.deptCode = this.user.deptCode;
        } else {
          this.condition.deptCode = null;
        }

        this.meta.loading = true;
        api.Bed.query(this.condition)
          .then((res) => {
            // this.emptyBeds = res.items;
            this.entities = res;
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.meta.loading = false;
          });
      },
      bedStyle(bed) {
        if (this.hospitalization && bed.ipNo == this.hospitalization.ipNo) {
          return {
            border: "1px #409EFF solid",
            color: "#409EFF",
            "margin-left": "0",
          };
        } else {
          return {
            "margin-left": "0",
          };
        }
      },
    },
  };
</script>
